import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { AlertCircle, BatteryWarning, XCircle } from 'lucide-react';
export function DoloresSection() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start center', 'end center']
  });
  const painPoints = [{
    id: 1,
    icon: <AlertCircle className="w-8 h-8 text-[#FF3535]" style={{
      filter: 'drop-shadow(0 0 8px rgba(255, 53, 53, 0.6))'
    }} data-id="element-58" />,
    text: <>
          TE DIJISTE{' '}
          <span className="text-[#FF3535] font-black" style={{
        textShadow: '0 0 20px rgba(255, 53, 53, 0.5)'
      }} data-id="element-59">
            MIL VECES
          </span>{' '}
          QUE IBAS A CAMBIAR, PERO SIGUES{' '}
          <span className="text-[#FF3535] font-black" style={{
        textShadow: '0 0 20px rgba(255, 53, 53, 0.5)'
      }} data-id="element-60">
            SIN CUMPLIRTE
          </span>
          .
        </>
  }, {
    id: 2,
    icon: <BatteryWarning className="w-8 h-8 text-[#FF3535]" style={{
      filter: 'drop-shadow(0 0 8px rgba(255, 53, 53, 0.6))'
    }} data-id="element-61" />,
    text: <>
          SIENTES QUE{' '}
          <span className="text-[#FF3535] font-black" style={{
        textShadow: '0 0 20px rgba(255, 53, 53, 0.5)'
      }} data-id="element-62">
            PERDISTE LA CONFIANZA
          </span>{' '}
          EN TI MISMO.
        </>
  }, {
    id: 3,
    icon: <XCircle className="w-8 h-8 text-[#FF3535]" style={{
      filter: 'drop-shadow(0 0 8px rgba(255, 53, 53, 0.6))'
    }} data-id="element-63" />,
    text: <>
          TERMINAS EL DÍA SINTIENDO QUE{' '}
          <span className="text-[#FF3535] font-black" style={{
        textShadow: '0 0 20px rgba(255, 53, 53, 0.5)'
      }} data-id="element-64">
            NO MANEJAS TU TIEMPO
          </span>{' '}
          NI{' '}
          <span className="text-[#FF3535] font-black" style={{
        textShadow: '0 0 20px rgba(255, 53, 53, 0.5)'
      }} data-id="element-65">
            TUS DECISIONES
          </span>
          .
        </>
  }];
  return <section id="dolores" className="py-24 bg-[#0A0A0A] relative overflow-hidden" ref={containerRef} data-id="element-66">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-67">
        <div className="text-center mb-16" data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-black text-white uppercase tracking-tight mb-4" data-id="element-69">
            Este sistema visual es{' '}
            <span className="text-[#FF3535]" style={{
            textShadow: '0 0 20px rgba(255, 53, 53, 0.4)'
          }} data-id="element-70">
              para ti si...
            </span>
          </h2>
          <div className="w-24 h-1 bg-[#FF3535] mx-auto rounded-full" style={{
          boxShadow: '0 0 10px #FF3535'
        }} data-id="element-71"></div>
        </div>

        <div className="relative grid grid-cols-[auto_1fr] gap-6 md:gap-16" data-id="element-72">
          {/* Progress Rail - Visible on all screens */}
          <div className="relative w-1 bg-gray-800 rounded-full h-full min-h-[400px] ml-2 md:ml-4" data-id="element-73">
            <motion.div className="absolute top-0 left-0 w-full bg-[#FF3535] rounded-full" style={{
            height: useTransform(scrollYProgress, [0, 1], ['0%', '100%']),
            boxShadow: '0 0 10px #FF3535, 0 0 20px rgba(255, 53, 53, 0.5)'
          }} data-id="element-74" />
          </div>

          {/* Cards Container */}
          <div className="space-y-12" data-id="element-75">
            {painPoints.map((point, index) => <motion.div key={point.id} initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-[#121212] border border-white/5 p-8 rounded-2xl hover:border-[#FF3535]/30 transition-colors duration-300 group" data-id="element-76">
                <div className="flex flex-col sm:flex-row gap-6 items-start" data-id="element-77">
                  <div className="p-4 bg-black rounded-xl border border-white/10 group-hover:border-[#FF3535]/50 transition-colors" data-id="element-78">
                    {point.icon}
                  </div>
                  <div data-id="element-79">
                    <p className="text-xl md:text-2xl text-white font-bold leading-relaxed uppercase tracking-tight" data-id="element-80">
                      {point.text}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}